/**
 * @generated SignedSource<<ce30b1816b81c729c9a9f7d76220e45b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSaveNoteValueMutation$variables = {
  actorId: string;
  actorSequenceNumber: number;
  employeeId?: string | null;
  noteId: string;
  pageId: string;
  value: string;
};
export type useSaveNoteValueMutation$data = {
  readonly note: {
    readonly page: {
      readonly setValue: {
        readonly currentValue: string;
        readonly id: string;
      };
    };
  };
};
export type useSaveNoteValueMutation$rawResponse = {
  readonly note: {
    readonly page: {
      readonly setValue: {
        readonly currentValue: string;
        readonly id: string;
      };
    };
  };
};
export type useSaveNoteValueMutation = {
  rawResponse: useSaveNoteValueMutation$rawResponse;
  response: useSaveNoteValueMutation$data;
  variables: useSaveNoteValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actorId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actorSequenceNumber"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "noteId"
      }
    ],
    "concreteType": "NoteMutation",
    "kind": "LinkedField",
    "name": "note",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "pageId"
          }
        ],
        "concreteType": "NotePageMutation",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "actorId",
                "variableName": "actorId"
              },
              {
                "kind": "Variable",
                "name": "actorSequenceNumber",
                "variableName": "actorSequenceNumber"
              },
              {
                "kind": "Variable",
                "name": "employeeId",
                "variableName": "employeeId"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "value"
              }
            ],
            "concreteType": "WidgetNotePage",
            "kind": "LinkedField",
            "name": "setValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveNoteValueMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSaveNoteValueMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "46312a503ad8c16f301034fd55d4f035",
    "id": null,
    "metadata": {},
    "name": "useSaveNoteValueMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveNoteValueMutation(\n  $noteId: ID!\n  $pageId: ID!\n  $value: String!\n  $actorSequenceNumber: Int!\n  $actorId: ID!\n  $employeeId: ID\n) {\n  note(id: $noteId) {\n    page(id: $pageId) {\n      setValue(value: $value, actorSequenceNumber: $actorSequenceNumber, actorId: $actorId, employeeId: $employeeId) {\n        id\n        currentValue\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "96dd98b4f3902daf6dd4e7886df7c9b2";

export default node;
